import React, { useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap'

import ListPagination from '../../_atoms/ListPagination/ListPagination'
import ListSkeleton from '../../_atoms/ListSkeleton/ListSkeleton'
import { useGetBulkPriceOperationDetailsMutation } from '../../../modules/store/datahubApi/datahubApi'

import styles from './styles.module.scss'

interface Props {
    isOpen: boolean
    closeModal: () => void
    operationId: string
}

export const ModalBulkPriceOperationDetails = ({ isOpen, closeModal, operationId }: Props) => {
    const [page, setPage] = useState(1)
    const perPage = 50
    const [fetchDetails, { data, isLoading }] = useGetBulkPriceOperationDetailsMutation()

    useEffect(() => {
        if (isOpen && operationId) {
            fetchDetails({
                operationId,
                pagination: { page, perPage },
            })
        }
    }, [fetchDetails, isOpen, operationId, page])

    useEffect(() => {
        if (isOpen) {
            setPage(1)
        }
    }, [isOpen, operationId])

    const items = data?.data || []
    const itemsCount = data?.dataCount || 0

    return (
        <Modal show={isOpen} onHide={closeModal} centered dialogClassName={styles.modal} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>
                    <b>Детали массового изменения цен</b>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Table striped hover size="sm">
                    <thead>
                        <tr>
                            <th>Запчасть</th>
                            <th>Артикул</th>
                            <th>Старая цена</th>
                            <th>Новая цена</th>
                        </tr>
                    </thead>
                    {isLoading ? (
                        <ListSkeleton rowCount={5} columnCount={4} marginVerticalRem={0.21} />
                    ) : (
                        <tbody>
                            {items.map(item => (
                                <tr key={item.partId}>
                                    <td>{item.title}</td>
                                    <td>{item.vendorCode}</td>
                                    <td>{item.priceBefore.toLocaleString('ru-RU')}</td>
                                    <td>{item.priceAfter.toLocaleString('ru-RU')}</td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </Table>
                {itemsCount > perPage && (
                    <ListPagination
                        page={page}
                        setPage={setPage}
                        perPage={perPage}
                        itemsCount={itemsCount}
                        justifyContent={'flex-end'}
                    />
                )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={closeModal}>
                    Закрыть
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
